module.exports = __webpack_public_path__ + "img/shoplineplugin.886b658b.png";